import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import { fetchAllTrainerData } from "../../../redux/reducers/apiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import "../../../styles/trainer-member/trainer-member-map.css";
import { convertTo12HourFormat } from "../../common-data/Converts";
import CalendarLoader from "../../common-components/CalendarLoader";

const TrainerMemberMap = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { loading: trainerDataLoading, trainerData } = useSelector(
    (state) => state.api
  );
  const { postPutLoading } = useSelector((state) => state.common);

  const [trainers, setTrainers] = useState([]);

  const forminitials = {
    selectedTrainer: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  // const onChangeDropdown = (value, name) => {
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const onSelectTrainer = (trainer) => {
    setFormValues((prev) => ({
      ...prev,
      selectedTrainer: trainer,
    }));
  };

  const getTrainerData = useCallback(
    (filters) => {
      dispatch(fetchAllTrainerData({ filters, token: userInfoData?.token }));
    },
    [dispatch, userInfoData?.token]
  );

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/member_engagement/assign_trainer";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.selectedTrainer) {
      errors.selectedTrainer = "Trainer is required!";
    }

    return errors;
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        user_id: rowData?.user_id || "",
        gym_id: rowData?.gym_id || "",
        trainer_id: formValues.selectedTrainer?.value || "",
        subscription_id: rowData?.subscription_id || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want change trainer from ${
          rowData?.trainer_name || "N/A"
        } to ${formValues.selectedTrainer?.label || "N/A"}?`,
        "Cancel",
        "Upload"
      );
    }
  };

  useEffect(() => {
    if (rowData?.gym_id) {
      const sendableLeadFilters = {
        page: 1,
        limit: 5000,
        status: "active",
        gym_id: rowData?.gym_id || "",
      };

      getTrainerData(sendableLeadFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !trainerDataLoading &&
      trainerData?.status &&
      trainerData?.data?.length > 0
    ) {
      const dropdownOptions = trainerData?.data.map((item) => ({
        label: `${item.name}/${item.mobile}`,
        value: item.user_id,
        info: item,
      }));

      setTrainers(dropdownOptions);
    } else {
      setTrainers([]);
    }
  }, [trainerDataLoading, trainerData]);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedTrainer" className={`formInputLabel`}>
              Select Trainer <span className="required">*</span>
            </label>

            <div
              className={`trainer-selection-container ${
                formErrors.selectedTrainer ? "formError" : ""
              }`}
            >
              {trainerDataLoading ? (
                <CalendarLoader daysCount={1} />
              ) : trainers.length > 0 ? (
                <div className="trainer-cards-grid">
                  {trainers.map((trainer) => {
                    const isSelected =
                      formValues.selectedTrainer?.value === trainer.value;
                    const shiftInfo = trainer.info?.shift_details?.[0];

                    return (
                      <div
                        key={trainer.value}
                        className={`trainer-card ${
                          isSelected ? "trainer-card--selected" : ""
                        }`}
                        onClick={() => onSelectTrainer(trainer)}
                      >
                        <div className="trainer-card-header">
                          <div className="trainer-avatar">
                            {trainer.info?.name?.charAt(0)?.toUpperCase() ||
                              "T"}
                          </div>
                          <div className="trainer-info">
                            <h4 className="trainer-name">
                              {trainer.info?.name || "N/A"}
                            </h4>
                            <p className="trainer-mobile">
                              📱 {trainer.info?.mobile || "N/A"}
                            </p>
                          </div>
                          {trainer?.info?.checkin_status && (
                            <span
                              className={`trainer-status-dot ${
                                trainer.info.checkin_status === "present"
                                  ? "trainer-status--present"
                                  : trainer.info.checkin_status === "absent"
                                  ? "trainer-status--absent"
                                  : trainer.info.checkin_status === "upcoming"
                                  ? "trainer-status--upcoming"
                                  : ""
                              }`}
                              data-status={trainer.info.checkin_status}
                              // title={trainer.info.checkin_status}
                            />
                          )}
                        </div>

                        {shiftInfo && (
                          <div className="trainer-shift">
                            <div className="shift-name">
                              {shiftInfo.shift_name}
                            </div>
                            <div className="shift-time">
                              {convertTo12HourFormat(shiftInfo?.start_time)} -{" "}
                              {convertTo12HourFormat(shiftInfo?.end_time)}
                            </div>
                          </div>
                        )}

                        {isSelected && (
                          <div className="trainer-selected-indicator">
                            ✓ Selected
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="no-trainers-message">
                  <p>No trainers available for this gym.</p>
                </div>
              )}
            </div>

            {/* <div
              className={`commonWrapper ${
                formErrors.selectedTrainer ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={trainers}
                selectedOption={formValues.selectedTrainer}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedTrainer")
                }
                name="Trainer"
                preventKeyboardOpen={true}
              />
            </div> */}
          </div>
        </div>

        <CloseSubmitBtn
          closeLabel="Cancel"
          submitLabel={"Submit"}
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={postPutLoading}
        />
      </form>
    </div>
  );
};

export default TrainerMemberMap;
